import React from 'react'
import {
    useParams
} from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchBuildings } from "../../reducers/buildingsSlice";
import { fetchRegions } from "../../reducers/regionsSlice";
import { fetchAlarmsCount } from '../../reducers/alarmsSlice';


import DailyView from './daily/DailyView';
import DisasterView from './disaster/DisasterView';
import EnergyView from './energy/EnergyView';
import { fetchHoliday } from 'reducers/holidaySlice';
import withHolidayTheme from "../../hocs/withHolidayTheme";

const ModeView = () => {
    const dispatch = useDispatch()
    let { mode } = useParams();

    // Fetch one time only
    useEffect(() => {
        dispatch(fetchHoliday())
        dispatch(fetchRegions())
        dispatch(fetchBuildings())
    },[])

    // Five Minutes Interval
    useEffect(() => {
        dispatch(fetchAlarmsCount())
        const timer = setInterval(() => { dispatch(fetchAlarmsCount()) }, 5 * 60 * 1000)
        return () => { clearInterval(timer) }
    }, [])

    return (
        <>
            {mode === 'daily' && <DailyView/>}
            {mode === 'energy' && <EnergyView/>}
            {mode === 'disaster' && <DisasterView/>}
        </>
    )

}

export default withHolidayTheme(ModeView)